import React from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';
import { setSessionStorage, routerPush, isClient, getMappedPageHref } from '@tcp/core/src/utils';

const PlpTileAnchor = ({
  pathName,
  setProductDataForPdp,
  pdpUrl,
  children,
  title,
  fromProductImage,
  isSLPTile,
}) => {
  const { href, asPath, asPathWithoutSlug } = pdpUrl;
  const [pathNameWithoutQuery, queryParam = ''] = pathName.split('?');

  const hanlePdplinkClick = (e) => {
    e.preventDefault();
    requestAnimationFrame(() => {
      window.isPdpLinkClicked = true;

      if (isSLPTile) {
        setSessionStorage({ key: 'LAST_PAGE_PATH', value: window.location.pathname });
        setSessionStorage({ key: 'SCROLL_POINT', value: window.pageYOffset });
      } else {
        setSessionStorage({ key: 'LAST_PAGE_PATH', value: pathNameWithoutQuery });
        setSessionStorage({ key: 'LAST_PAGE_QUERY_PARAM', value: queryParam });

        if (isClient()) {
          setSessionStorage({ key: 'SCROLL_POINT_VIA_NEW_PLP', value: window.scrollY });
        }
      }
      routerPush(href, asPathWithoutSlug);
      setProductDataForPdp(fromProductImage);
    });
  };

  const incomingUrl = getMappedPageHref(href);

  return (
    <Link href={incomingUrl} as={asPath} scroll={false} legacyBehavior>
      <a href={asPath} onClick={hanlePdplinkClick} target="_self" title={title}>
        {children}
      </a>
    </Link>
  );
};
PlpTileAnchor.propTypes = {
  children: PropTypes.node.isRequired,
  pdpUrl: PropTypes.shape({
    asPath: PropTypes.string,
    href: PropTypes.string,
    asPathWithoutSlug: PropTypes.string,
  }),
  title: PropTypes.string,
  pathName: PropTypes.string.isRequired,
  setProductDataForPdp: PropTypes.func,
  fromProductImage: PropTypes.bool,
  isSLPTile: PropTypes.bool,
};
PlpTileAnchor.defaultProps = {
  pdpUrl: {},
  title: '',
  setProductDataForPdp: () => {},
  fromProductImage: false,
  isSLPTile: false,
};
export default PlpTileAnchor;
